import {
  IdCard,
  LayoutTemplate,
  UserCheck,
  FileText,
  Plus,
  Minus,
  X,
  ChartBarIncreasing,
  LogOutIcon,
  Badge,
  Bot,
} from "lucide-react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const menuItems = [
  // {
  //   name: "Books",
  //   icon: <BookOpen />,
  //   key: "books",
  //   roles: ["admin"],
  //   children: [
  //     { label: "Add Book", path: "/add-book" },
  //     { label: "Books List", path: "/books-list" },
  //   ],
  // },
  // {
  //   name: "Mentors",
  //   icon: <Users />,
  //   key: "mentor",
  //   roles: ["admin"],
  //   children: [
  //     { label: "Add Mentor", path: "/add-mentor" },
  //     { label: "Mentor List", path: "/mentor-list" },
  //   ],
  // },
  {
    name: "Users",
    icon: <IdCard />,
    path: "/users-list",
    roles: ["admin"],
  },
  // {
  //   name: "Events",
  //   icon: <Calendar />,
  //   key: "events",
  //   roles: ["admin"],
  //   children: [
  //     { label: "Add Event", path: "/add-events" },
  //     { label: "Events List", path: "/events-list" },
  //   ],
  // },
  // {
  //   name: "Certificates",
  //   icon: <Award />,
  //   key: "cert",
  //   roles: ["admin"],
  //   children: [
  //     { label: "Add Certificate", path: "/add-certificate" },
  //     { label: "Certificates List", path: "/certificates-list" },
  //   ],
  // },
  {
    name: "Templates",
    icon: <LayoutTemplate />,
    key: "templates",
    roles: ["admin"],
    children: [
      { label: "Add Template", path: "/add-templates" },
      { label: "Templates List", path: "/templatess-list" },
    ],
  },
  {
    name: "Logs",
    icon: <FileText />,
    key: "logs",
    roles: ["admin"],
    children: [
      { label: "Frontend Logs", path: "/frontend-logs" },
      { label: "Visitor Logs", path: "/visiter-logs" },
      { label: "Activity Logs", path: "/activity-logs" },
    ],
  },
  {
    name: "Recruiter",
    icon: <UserCheck />,
    path: "/approve-recruiter",
    roles: ["admin"],
  },
  {
    name: "Leads",
    icon: <ChartBarIncreasing />,
    path: "/leads",
    roles: ["admin", "lead_manager"],
  },
  {
    name: "Ambassador",
    icon: <Badge />,
    path: "/ambassador-user",
    roles: ["admin", "lead_manager"],
  },
  {
    name: "Token Usage",
    icon: <Bot />,
    path: "/token-usage",
    roles: ["admin"],
  },
];

export default function Leftbar({ isCollapsed, isMobileOpen, closeMobile }) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const role = localStorage.getItem("role")?.toLowerCase();

  const filteredMenuItems = menuItems.filter(
    (item) => !item.roles || item.roles.includes(role),
  );

  const toggleDropdown = (key) => {
    setOpenDropdown(openDropdown === key ? null : key);
  };

  return (
    <aside
      className={`left-sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "mobile-open" : ""}`}
    >
      <div className="sidebar-header d-flex align-items-center justify-content-between px-3 py-3">
        <Link to="/dashboard">
          <img
            src={isCollapsed ? "/favicon.ico" : "/assets/logo.png"}
            width={isCollapsed ? 32 : 140}
            alt="logo"
          />
        </Link>
        <button className="btn text-white d-lg-none p-0" onClick={closeMobile}>
          <X size={24} />
        </button>
      </div>

      <nav className="sidebar-nav mt-2">
        <ul className="list-unstyled">
          {filteredMenuItems.map((item) => (
            <li key={item.name} className="px-2 mb-1">
              {item.children ? (
                <>
                  <button
                    className={`nav-link-btn w-100 d-flex justify-content-between ${
                      openDropdown === item.key ? "active" : ""
                    }`}
                    onClick={() => toggleDropdown(item.key)}
                  >
                    <div className="d-flex align-items-center gap-3">
                      {item.icon}
                      {!isCollapsed && <span>{item.name}</span>}
                    </div>
                    {!isCollapsed &&
                      (openDropdown === item.key ? (
                        <Minus size={14} />
                      ) : (
                        <Plus size={14} />
                      ))}
                  </button>

                  <div
                    className={`submenu-collapse ${openDropdown === item.key ? "show" : ""}`}
                  >
                    {item.children.map((sub) => (
                      <Link
                        key={sub.path}
                        to={sub.path}
                        className={`sub-link ${location.pathname === sub.path ? "active" : ""}`}
                        onClick={closeMobile}
                      >
                        {sub.label}
                      </Link>
                    ))}
                  </div>
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`nav-link-btn d-flex gap-3 ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                  onClick={closeMobile}
                >
                  {item.icon}
                  {!isCollapsed && <span>{item.name}</span>}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <div
        className="sidebar-footer"
        onClick={() => {
          localStorage.clear();
          sessionStorage.clear();
          navigate("/login");
        }}
      >
        <button className="w-100 d-flex justify-content-center gap-2 logout-btn">
          {!isCollapsed && <span>Log Out</span>}
          <LogOutIcon />
        </button>
      </div>
      <style>{`
      .logout-btn {
        background: rgba(254, 48, 16, 1);
        color: #fff;
        padding: 10px 14px;
        border-radius: 8px;
        transition: all 0.2s;
      }

      .logout-btn:hover{
        background: rgba(254, 48, 16, 0.8);
        color : #fff;
      }
      .sidebar-footer {
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 100%;
        padding: 0 10px;
      }
        .sidebar-footer .nav-link-btn:hover {
        background: #7f1d1d;
        color: #fff;
      }
      .left-sidebar {
        width: 260px;
        background: #fff;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1050;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        color: #f8fafc;
      }

      .left-sidebar.collapsed { width: 80px; }

      .nav-link-btn {
        background: transparent;
        border: none;
        color: #000;
        padding: 10px 14px;
        border-radius: 8px;
        transition: all 0.2s;
        text-decoration: none;
      }

      .nav-link-btn:hover, .nav-link-btn.active {
        background: #6600cc;
        color: #fff;
      }

      .submenu-collapse {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out;
        padding-left: 45px;
      }

      .submenu-collapse.show {
        max-height: 500px;
        color : #000 
      }

      .sub-link {
        display: block;
        padding: 8px 0;
        color: #000;
        font-size: 0.9rem;
        text-decoration: none;
      }

      .sub-link:hover, .sub-link.active { color: #6600cc; }

      @media (max-width: 991px) {
        .left-sidebar { transform: translateX(-100%); }
        .left-sidebar.mobile-open { transform: translateX(0); }
        .left-sidebar.collapsed { width: 260px; } /* Don't collapse on mobile */
      }
      `}</style>
    </aside>
  );
}
